const poweredChoices = {
  IGNITED: {
    id: "IGNITED",
    name: "Ignited"
  },
  POWERED: {
    id: "POWERED",
    name: "Powered"
  },
  CONNECTED: {
    id: "CONNECTED",
    name: "Connected"
  },
  HIGH: {
    id: "HIGH",
    name: "High Voltage"
  },
  LEARN_MORE: {
    id: "LEARN_MORE",
    name: "Learn More"
  },
  NOT_SET: {
    id: "NOT_SET",
    name: "I'm not interested"
  }
};

export const poweredLevels = [
  {
    id: poweredChoices.POWERED.id,
    name: poweredChoices.POWERED.name,
    description: [
      "$4,000 Contribution and up",
      "Nominate experts, organizations and future themes",
      "Vote for your favorite organizations for funding",
      "One person"
    ],
    intro: ""
  },
  {
    id: poweredChoices.CONNECTED.id,
    name: poweredChoices.CONNECTED.name,
    description: [
      "$20,000 Contribution and up",
      "Attend VIP events",
      "Nominate experts, organizations and future themes",
      "Vote for your favorite organizations for funding",
      "Two people (second person can be a non-Battery member)"
    ],
    intro: ""
  },
  {
    id: poweredChoices.HIGH.id,
    name: poweredChoices.HIGH.name,
    description: [
      "$100,000 Contribution and up",
      "Strategic involvement in Battery Powered program",
      "Finalize program themes",
      "Attend VIP events",
      "Nominate experts, organizations and future themes",
      "Vote for your favorite organizations for funding",
      "Two people (second person can be a non-Battery member)"
    ],
    intro: ""
  }
];

export default poweredChoices;
